import LoaderItem from "./components/Loader"
import LoaderContainer from "./components/Container"

const Loader = LoaderItem

export default Loader
export { LoaderContainer }